var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-preloader",style:({ display: _vm.show ? 'block' : 'none' })},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"preloader"}},[_c('div',{attrs:{"id":"loader"}})])
}]

export { render, staticRenderFns }